module.exports = __webpack_public_path__ + "img/vivo_03.c2278235.jpg";